import { Component } from 'react';

import PropTypes from 'prop-types';

import { getCompanyQueryKey, loadQuery } from 'common/actions/thirdPartyCompanyQueries';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import connect from 'common/core/connect';

function getQueryParams(location) {
  const { query } = location;

  const search = query.search ? query.search.trim() : null;
  const segmentURLName = query.segment ? query.segment.trim() : null;

  return {
    ...(search && { search }),
    ...(segmentURLName && { segmentURLName }),
    limit: 5,
  };
}

class ThirdPartyCompanyListContainerV2 extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      state: PropTypes.object,
    }),
    thirdPartyCompanies: PropTypes.object,
    thirdPartyCompanyQueries: PropTypes.object,
    loadQuery: PropTypes.func,
  };

  componentDidMount() {
    const { loadQuery, location } = this.props;
    const params = getQueryParams(location);
    // Don't load third party companies unless we're actually searching
    if (params.search) {
      loadQuery(location);
    }
  }

  componentDidUpdate(prevProps) {
    const { loadQuery, location } = this.props;
    // Only call loadQuery if the location actually changed
    if (prevProps.location !== location) {
      const params = getQueryParams(location);
      // Don't load third party companies unless we're actually searching
      if (params.search) {
        loadQuery(location);
      }
    }
  }

  render() {
    const { children, location, thirdPartyCompanies, thirdPartyCompanyQueries } = this.props;
    const companyQueryKey = getCompanyQueryKey(getQueryParams(location));
    const companyQueryResult = Object.assign(
      { loading: true },
      thirdPartyCompanyQueries[companyQueryKey],
    );
    if (companyQueryResult.companyIDs) {
      companyQueryResult.companies = companyQueryResult.companyIDs.map((companyID) => {
        return thirdPartyCompanies[companyID];
      });
    }

    return cloneElementWithProps(children, {
      ...this.props,
      companyList: companyQueryResult,
    });
  }
}

export default connect(
  (state) => ({
    thirdPartyCompanies: state.thirdPartyCompanies,
    thirdPartyCompanyQueries: state.thirdPartyCompanyQueries,
  }),
  (dispatch) => ({
    loadQuery: (location) => dispatch(loadQuery(getQueryParams(location))),
  }),
)(ThirdPartyCompanyListContainerV2);
